<div id="wrapper">
    <!-- <app-navbar></app-navbar> -->
    <div class="navbar-custom">
        <div class="container-fluid">
            <div class="row">
                <div class="col-6">
                    <nav
                        style="--bs-breadcrumb-divider: ''"
                        aria-label="breadcrumb"
                        class="pt-2"
                    >
                        <div class="breadcrumb">
                            <span class="breadcrumb-item">
                                <a href="javascript:void(0)">PayEXAP</a>
                            </span>
                            <span class="px-2"
                                ><i class="ri-arrow-right-s-line"></i
                            ></span>
                            <span class="breadcrumb-item" aria-current="page">
                                <a routerLink="/credit-notes">Credit Notes</a>
                            </span>
                        </div>
                    </nav>
                </div>
                <div class="col-6">
                    <ul class="navbar-nav list-unstyled topnav-menu float-end">
                        <li class="nav-item dropdown nav-user">
                            <span
                                class="pro-user-name ms-1 dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {{ displayName }}
                                <!-- <i
                  class="mdi mdi-chevron-down "
                  
                ></i> -->
                            </span>
                            <ul class="dropdown-menu">
                                <li>
                                    <a
                                        class="dropdown-item"
                                        routerLink="/vendor-profile"
                                    >
                                        <i class="ri-user-3-line"></i>
                                        <span class="ml-2">Vendor Profile</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        class="dropdown-item"
                                        routerLink="/-password"
                                    >
                                        <i class="ri-lock-2-line"></i>
                                        <span class="ml-2"
                                            >Change Password</span
                                        >
                                    </a>
                                </li>
                                <li>
                                    <a
                                        class="dropdown-item"
                                        routerLink="/sign-in"
                                    >
                                        <i class="ri-logout-box-line"></i>
                                        <span class="ml-2"> Logout</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>

    <app-sidebar></app-sidebar>

    <div class="content">
        <div class="content-pane">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="pane-header">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h4 class="py-4">
                                                Manage Credit Notes
                                            </h4>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                class="dropdown float-end mt-3"
                                            >
                                                <button
                                                    class="btn btn-invoice"
                                                    [routerLink]="['/invoices']"
                                                >
                                                    Submit Credit Note
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="search-pane py-4">
                                    <div class="row">
                                        <div class="col-md-2 col-sm-4">
                                            <label
                                                class="d-inline-flex align-items-center mb-3"
                                            >
                                                <select
                                                    id="show-headers"
                                                    class="form-select form-select-sm mx-1"
                                                >
                                                    <option value="5">
                                                        Document No.
                                                    </option>
                                                    <option value="10">
                                                        Doc Type
                                                    </option>
                                                    <option value="15">
                                                        Bar Code No.
                                                    </option>
                                                    <option value="20">
                                                        PO No.
                                                    </option>
                                                    <option value="">
                                                        Current Status
                                                    </option>
                                                </select>
                                            </label>
                                        </div>
                                        <div class="col-md-4 col-sm-8">
                                            <div
                                                class="input-group flex-nowrap"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="search..."
                                                    aria-label="search"
                                                    aria-describedby="addon-wrapping"
                                                />
                                                <span
                                                    class="input-group-text"
                                                    id="addon-wrapping"
                                                    ><i
                                                        class="ri-search-line"
                                                    ></i
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-responsive">
                                    <table
                                        aria-describedby="credit-notes"
                                        id="demo-foo-pagination"
                                        class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint footable-loaded footable purchase-orders text-nowrap"
                                        data-page-size="5"
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    class="footable-visible footable-sortable"
                                                >
                                                    Document Number
                                                    <span
                                                        ><i
                                                            class="bi bi-chevron-expand"
                                                        ></i
                                                    ></span>
                                                </th>

                                                <th
                                                    class="footable-visible footable-sortable"
                                                >
                                                    Doc Type
                                                    <span
                                                        ><i
                                                            class="bi bi-chevron-expand"
                                                        ></i
                                                    ></span>
                                                </th>

                                                <th
                                                    class="footable-visible footable-sortable"
                                                >
                                                    Bar Code No.
                                                    <span
                                                        ><i
                                                            class="bi bi-chevron-expand"
                                                        ></i
                                                    ></span>
                                                </th>

                                                <th
                                                    class="footable-visible footable-sortable"
                                                >
                                                    PO No.
                                                    <span
                                                        ><i
                                                            class="bi bi-chevron-expand"
                                                        ></i
                                                    ></span>
                                                </th>

                                                <th
                                                    class="footable-visible footable-sortable"
                                                >
                                                    Invoice Amount
                                                    <span
                                                        ><i
                                                            class="bi bi-chevron-expand"
                                                        ></i
                                                    ></span>
                                                </th>

                                                <th
                                                    class="footable-visible footable-sortable"
                                                >
                                                    Current Status
                                                    <span
                                                        ><i
                                                            class="bi bi-chevron-expand"
                                                        ></i
                                                    ></span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                class="footable-even footable-detail-show"
                                            >
                                                <!-- <td class="footable-visible footable-first-column">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                          </div>
                        </td> -->
                                                <td>262002075</td>
                                                <td>ZSRD</td>
                                                <td>123678907</td>
                                                <td>3O1233224</td>
                                                <td>6,000.00</td>
                                                <td>
                                                    <span
                                                        class="badge text-bg-primary status-submission"
                                                        >Credit Note Pending
                                                        Submission</span
                                                    >
                                                </td>
                                            </tr>

                                            <tr
                                                class="footable-even footable-detail-show"
                                                *ngFor="let note of creditNotes"
                                            >
                                                <td>
                                                    {{ note.invoice_number }}
                                                </td>
                                                <td>
                                                    {{ note.doc_type }}
                                                </td>
                                                <td>
                                                    {{ note.bar_cod }}
                                                </td>
                                                <td>
                                                    {{ note.po_number }}
                                                </td>
                                                <td>
                                                    {{ note.invoice__amount }}
                                                </td>
                                                <td>
                                                    <span
                                                        class="badge text-bg-primary status-processing"
                                                        >{{
                                                            note.current_status
                                                        }}</span
                                                    >
                                                </td>
                                            </tr>
                                            <!-- <tr class="footable-row-detail" style="">
                          <td class="footable-row-detail-cell" colspan="3">
                            <div class="footable-row-detail-inner">
                              <div class="footable-row-detail-row">
                                <div class="footable-row-detail-name">DOB:</div>
                                <div class="footable-row-detail-value">
                                  22 Jun 1972
                                </div>
                              </div>
                              <div class="footable-row-detail-row">
                                <div class="footable-row-detail-name">
                                  Status:
                                </div>
                                <div class="footable-row-detail-value">
                                  <span class="badge label-table bg-success"
                                    >Active</span
                                  >
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr> -->
                                        </tbody>
                                        <tfoot></tfoot>
                                    </table>
                                    <div class="table-footer py-5">
                                        <div class="row">
                                            <div class="col-sm-5">
                                                <label
                                                    class="d-inline-flex align-items-center mb-3"
                                                >
                                                    Show
                                                    <select
                                                        id="demo-show-entries"
                                                        class="form-select form-select-sm mx-1"
                                                    >
                                                        <option value="5">
                                                            10
                                                        </option>
                                                        <option value="10">
                                                            25
                                                        </option>
                                                        <option value="15">
                                                            50
                                                        </option>
                                                        <option value="20">
                                                            100
                                                        </option>
                                                    </select>
                                                    entries
                                                </label>
                                            </div>
                                            <div class="col-sm-7">
                                                <div class="text-end">
                                                    <!-- Showing 1-5 of 15 entries -->
                                                    <ul
                                                        class="pagination pagination-split footable-pagination justify-content-end"
                                                    >
                                                        <li
                                                            class="page-item disabled"
                                                        >
                                                            <a class="page-link"
                                                                ><i
                                                                    class="ri-arrow-left-s-line"
                                                                ></i
                                                            ></a>
                                                        </li>
                                                        <li
                                                            class="page-item active"
                                                            aria-current="page"
                                                        >
                                                            <a
                                                                class="page-link"
                                                                href="#"
                                                                >1</a
                                                            >
                                                        </li>
                                                        <!-- <li class="page-item active" aria-current="page">
                              <a class="page-link" href="#">2</a>
                            </li>
                            <li class="page-item">
                              <a class="page-link" href="#">...</a>
                            </li> -->
                                                        <li
                                                            class="page-item disabled"
                                                        >
                                                            <a
                                                                class="page-link"
                                                                href="#"
                                                                ><i
                                                                    class="ri-arrow-right-s-line"
                                                                ></i
                                                            ></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
